// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

    // Start Boost 154421
    InstantSearchApi.beforeCall = function(searchTerm) {
      Globals.instantSearchQueryParams.q = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' '));
      if (!Globals.instantSearchQueryParams.q) Globals.instantSearchQueryParams.q = searchTerm // avoid breaking the search
    }
    
    var searchSubmit = SearchInput.prototype._onSubmit;
      
    SearchInput.prototype._onSubmit = function(event, redirect) {
      searchSubmit.call(this, event, redirect);
      
      var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, '').replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ').replace(/&#x2F;/g, ' ');
      var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
      
      var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
      
      if (isApiReturnedResult) {
        if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
          Utils.setWindowLocation(redirectUrl);
        } else {
          this.isChangePage = true;
          this.$searchForm[0].submit();
        }
      } 
    }
    
    InstantSearchResultItemProduct.prototype.compileTemplate = function () {
      if (this.isShow) {
          var searchTerm = Utils.stripHtml(Globals.currentTerm);
        
          // Product image
          var imageHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
              imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
              imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
          }

          // Product title
          var productTitle = this.customizeProductTitle();
          productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          
          // SKU
          var skuHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
              skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
              skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
          }

          // Vendor
          var vendorHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
              vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
              vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
          }
          // Price
          var priceHTML = this.compileSuggestionProductPrice();
          // Open the result item in new tab when selected
          var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
       
          // Found variant based on search term
          var itemUrl = this.url;
        
          if (this.data.hasOwnProperty('skus')) {
            var variantSKU = this.data.skus.filter(function(skuValue) {
              return skuValue.toLowerCase() == searchTerm.toLowerCase();
            })

            // Found variant ID based on the sku
            var variantID = this.data.variants.filter(function(varID) {              
              if (varID.sku === variantSKU[0]) return varID.id;
            })
            
            if (typeof variantSKU[0] !== 'undefined' && typeof variantID[0] !== 'undefined') {
              // Get variant ID url
              itemUrl += '?variant=' + variantID[0]['id'];
              // Change variant image 
              imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
              imageHTML = imageHTML.replace(/{{imageUrl}}/g, variantID[0]['image']);              
            }
          }

          return this.getTemplate()
              .replace(/{{id}}/g, this.id)
              .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
              .replace(/{{url}}/g, itemUrl)
              .replace(/{{newTabAttribute}}/g, newTabAttr)
              .replace(/{{itemProductImage}}/g, imageHTML)
              .replace(/{{title}}/g, productTitle)
              .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
              .replace(/{{itemProductSku}}/g, skuHTML)
              .replace(/{{itemProductVendor}}/g, vendorHTML)
              .replace(/{{itemProductPrice}}/, priceHTML)
              .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
              .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
              .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
      } else {
          return '';
      }
    }

  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
        this.prepareSuggestionProductPriceData();

        var searchTerm = Utils.stripHtml(Globals.currentTerm);

        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_min);
        var compareAtPrice = "";
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue("search.removePriceDecimal")) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }

        if (this.data.hasOwnProperty('skus')) {
            // var variantSKU = this.data.skus.filter(function(skuValue) {
            //   return skuValue.toLowerCase() == searchTerm.toLowerCase();
            // })
            // Found variant ID based on the sku
            // var variantID = this.data.variants.filter(function(varID) {              
            //   if (varID.sku === variantSKU[0]) return varID.id;
            // })
            
            // if (typeof variantSKU[0] !== 'undefined' && typeof variantID[0] !== 'undefined') {
            //   onSale = variantID[0].compare_at_price > variantID[0].price;
            //   // Format variant price
            //   console.log('DATA??:', this.data);
            //   console.log('variant price', variantID[0]);

            //   var variant_regular_price = variantID[0].price.split(".")[0];
              
            //   price = Utils.formatMoney(variant_regular_price);

            //   var compareAtPrice = "";
            //   if (variantID[0] && variantID[0].compare_at_price) {
            //       var variant_sale_price = variantID[0].compare_at_price.split(".")[0];
            //       compareAtPrice = Utils.formatMoney(variant_sale_price);
            //       if (Settings.getSettingValue("search.removePriceDecimal")) {
            //           price = Utils.removeDecimal(price);
            //           compareAtPrice = Utils.removeDecimal(compareAtPrice);
            //       }
            //   }
            // }

            /* Henry fixed */
            var variantSKU = this.data.skus.filter(function(skuValue) {
              return skuValue.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
            })
            // Found variant ID based on the sku
            if (typeof variantSKU[0] !== 'undefined') {
              var variantID = this.data.variants.filter(function(varID) {              
                if (varID.sku === variantSKU[0]) return varID.id;
              })
              
              if (typeof variantID[0] !== 'undefined') {
                onSale = variantID[0].compare_at_price > variantID[0].price;
                // Format variant price
                var variant_regular_price = variantID[0].price.split(".")[0];
                
                price = Utils.formatMoney(variant_regular_price);
  
                var compareAtPrice = "";
                if (variantID[0] && variantID[0].compare_at_price) {
                    var variant_sale_price = variantID[0].compare_at_price.split(".")[0];
                    compareAtPrice = Utils.formatMoney(variant_sale_price);
                    if (Settings.getSettingValue("search.removePriceDecimal")) {
                        price = Utils.removeDecimal(price);
                        compareAtPrice = Utils.removeDecimal(compareAtPrice);
                    }
                }
              }
            }
        }

        // Build Price
        var result = "";
        if (Settings.getSettingValue("search.showSuggestionProductPrice")) {
            if (onSale && Settings.getSettingValue("search.showSuggestionProductSalePrice")) {
                result = this.getTemplate(
                    InstantSearchResultItemProduct.tempType.PRICE_SALE
                );
            } else {
                result = this.getTemplate(
                    InstantSearchResultItemProduct.tempType.PRICE
                );
            }
        }

        // var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
        // if (priceVaries) {
        //     price = "From " + price;
        // }
        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
    // End Boost 154421

    // #158780
    InstantSearchApi.beforeCall = function(searchTerm) {
        /* Change the filter params before calling api */
        Globals.instantSearchQueryParams.h_options = []
        if(typeof(boostPFSAppConfig.general.customer_tag) !== 'undefined' && boostPFSAppConfig.general.customer_tag !== null && boostPFSAppConfig.general.customer_tag !== '' && boostPFSAppConfig.general.customer_tag.indexOf('CLUB') !== -1
           || typeof(boostPFSAppConfig.general.customer_tag) !== 'undefined' && boostPFSAppConfig.general.customer_tag !== null && boostPFSAppConfig.general.customer_tag !== '' && boostPFSAppConfig.general.customer_tag.indexOf('club') !== -1
           || typeof(boostPFSAppConfig.general.customer_tag) !== 'undefined' && boostPFSAppConfig.general.customer_tag !== null && boostPFSAppConfig.general.customer_tag !== '' && boostPFSAppConfig.general.customer_tag.indexOf('Club') !== -1){
          // Globals.instantSearchQueryParams.h_options.push('bcclub');
        }else{
          Globals.instantSearchQueryParams.h_options.push('bcnoclub');
        }
        /* No need to return anything */
    }
  // End #158780
})();